import { CampaignAPI } from "generated-api"

export enum AUCTION_TYPES {
  FIRST_PRICE = 1, // First price
  SECOND_PRICE = 2, // Second price
  EXACT_PRICE = 3
}
export const ALL_AUCTION_TYPES: AUCTION_TYPES[] = [
  AUCTION_TYPES.FIRST_PRICE,
  AUCTION_TYPES.SECOND_PRICE,
  AUCTION_TYPES.EXACT_PRICE
]
export const CAMPAIGN_AUCTION_TYPES: AUCTION_TYPES[] = [AUCTION_TYPES.FIRST_PRICE, AUCTION_TYPES.SECOND_PRICE]
export const SSP_DEAL_AUCTION_TYPES: AUCTION_TYPES[] = ALL_AUCTION_TYPES.slice()
export const getDefaultAuctionTypes = (isDspDeal: boolean): AUCTION_TYPES[] =>
  isDspDeal ? [] : [AUCTION_TYPES.FIRST_PRICE, AUCTION_TYPES.SECOND_PRICE]

export type IAuction = Awaited<ReturnType<typeof CampaignAPI.getApiCampaignAuctionTypeList>>[0]

export interface IAuctionRepository {
  getAuctions(campaignId: number): Promise<IAuction[]>
  addAuction(campaignId: number, auctionType: AUCTION_TYPES): Promise<IAuction>
  deleteAuction(campaignId: number, auction: IAuction): Promise<void>
}
